/**
 * @generated SignedSource<<3cf28df01d5346f9bf4737e790afb93b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonTypeSelect_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_facility">;
  readonly " $fragmentType": "LessonTypeSelect_facility";
};
export type LessonTypeSelect_facility$key = {
  readonly " $data"?: LessonTypeSelect_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonTypeSelect_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLessonTypeOptions_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "c48a1cc12192deecb3bed21382c9a5fe";

export default node;
